var map = {
	"./pageConfig_admission_referral_form.json": [
		"./src/features/widgets/form_config/pageConfig_admission_referral_form.json",
		"src_features_widgets_form_config_pageConfig_admission_referral_form_json"
	],
	"./pageConfig_alumni_occupation.json": [
		"./src/features/widgets/form_config/pageConfig_alumni_occupation.json",
		"src_features_widgets_form_config_pageConfig_alumni_occupation_json"
	],
	"./pageConfig_appeal_video.json": [
		"./src/features/widgets/form_config/pageConfig_appeal_video.json",
		"src_features_widgets_form_config_pageConfig_appeal_video_json"
	],
	"./pageConfig_cover_banner.json": [
		"./src/features/widgets/form_config/pageConfig_cover_banner.json",
		"src_features_widgets_form_config_pageConfig_cover_banner_json"
	],
	"./pageConfig_current_location_country.json": [
		"./src/features/widgets/form_config/pageConfig_current_location_country.json",
		"src_features_widgets_form_config_pageConfig_current_location_country_json"
	],
	"./pageConfig_directory_stats.json": [
		"./src/features/widgets/form_config/pageConfig_directory_stats.json",
		"src_features_widgets_form_config_pageConfig_directory_stats_json"
	],
	"./pageConfig_enquiry_form.json": [
		"./src/features/widgets/form_config/pageConfig_enquiry_form.json",
		"src_features_widgets_form_config_pageConfig_enquiry_form_json"
	],
	"./pageConfig_top_careers.json": [
		"./src/features/widgets/form_config/pageConfig_top_careers.json",
		"src_features_widgets_form_config_pageConfig_top_careers_json"
	],
	"./pageConfig_top_colleges.json": [
		"./src/features/widgets/form_config/pageConfig_top_colleges.json",
		"src_features_widgets_form_config_pageConfig_top_colleges_json"
	],
	"./pageConfig_top_companies.json": [
		"./src/features/widgets/form_config/pageConfig_top_companies.json",
		"src_features_widgets_form_config_pageConfig_top_companies_json"
	],
	"./pageConfig_top_industries.json": [
		"./src/features/widgets/form_config/pageConfig_top_industries.json",
		"src_features_widgets_form_config_pageConfig_top_industries_json"
	],
	"./pageConfig_top_study_country.json": [
		"./src/features/widgets/form_config/pageConfig_top_study_country.json",
		"src_features_widgets_form_config_pageConfig_top_study_country_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/features/widgets/form_config lazy recursive ^\\.\\/pageConfig_.*\\.json$";
module.exports = webpackAsyncContext;